import { defineComponent as _defineComponent } from 'vue'
import type { PropType } from 'vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'SearchBreadcrumbs',
  props: {
    breadcrumbs: {
      required: true,
      type: Array as PropType<{ id: string; title: string; url?: string }[]>,
    },
  },
  setup(__props) {

  

return { __sfc: true, }
}

})